import RemoveBeneficiaryError from './RemoveBeneficiaryError';
class RemoveBeneficiaryInvalidId extends RemoveBeneficiaryError {
    constructor(options) {
        super('The beneficiary ID to be deleted must be a valid UUID', options);
    }
}
export default RemoveBeneficiaryInvalidId;
